import React from "react";
import NewUsers from "../../global/newUsers";
import ExistingUsers from "../../global/existingUsers";

const renderComponent = component => {
  switch (component.stepType) {
    case "newUser":
      return <NewUsers content={component} />;
    case "existingUsers":
      return <ExistingUsers content={component} />;
    default:
      return null;
  }
};

export default function PageStepScreenshots({ component }) {
  return renderComponent(component);
}
